import useSWR, { KeyedMutator } from "swr";
import { User } from "../_interfaces";
import { fetcher, userLogout } from "../_services/fetcher";
import { gqlRequest } from "../_services/gqlRequests";

export const useUser = (immutable?: boolean): 
{
    user: User, 
    loading: boolean, 
    loggedOut: boolean, 
    mutate: KeyedMutator<any>,
    isValidating: boolean,
    logout: () => Promise<void>
} => {

    const { data, mutate, error, isValidating } = useSWR({ query: gqlRequest.useUser }, fetcher, 
        immutable ?
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        } : {}
    );

    const loading = !data && !error;

    const loggedOut = error && error.status === 403;

    const logout = async (): Promise<void> => {
        await userLogout().then(() => mutate())
        .catch(e => {
            console.error('error in logout')
            console.error(e)
        });
    }

    return {
        loading,
        loggedOut,
        user: data,
        mutate,
        isValidating,
        logout
    };
}